import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Box, Typography, Paper, Stack, TextField, Tooltip } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { updateMachineModel, createMachineModel } from "../../../features/machines/actions";
import { readAsyncStorageValues } from "../../../features/common/actions";

const AddEditMachineModel = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { machineModels } = useSelector((state) => state.common);
  const [enableEdit, setEnableEdit] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(readAsyncStorageValues());
  }, [dispatch]);

  useEffect(() => {
    if (id) setFormData(machineModels.find((item) => item.id == id) || {});
    if (state?.enableEdit || !id) setEnableEdit(true);
  }, [dispatch]);

  const handleSaveButton = () => {
    // Check if selectedModel is not null before accessing its properties
    if (!formData.manufacturer || !formData.model) {
      setErrors({
        model: formData.model || "Please enter model!",
        manufacturer: formData.manufacturer || "Please enter manufacturer!",
      });
      return toast.warn(` Please enter required fields! `);
    }
    const updateObj = {
      manufacturer: formData.manufacturer,
      modelName: formData.model,
    };

    const modelExist = machineModels.filter(
      (item) =>
        item.model.toLowerCase() === updateObj.modelName.toLowerCase() &&
        item.manufacturer.toLowerCase() === updateObj.manufacturer.toLowerCase() &&
        item.id !== id
    );

    if (modelExist.length) return toast.warn(`Model already exist with same model name and manufacturer! `);

    if (id) {
      updateObj.modelId = id;
      submitForm(updateMachineModel, updateObj);
    } else submitForm(createMachineModel, updateObj);
  };

  const submitForm = (action, updateObj) => {
    dispatch(action(updateObj)).then((res) => {
      dispatch(readAsyncStorageValues());
      setEnableEdit(false);
      if (res?.payload?.status && res?.payload?.data) {
        navigate(`/edit-machine-model/` + res.payload.data.id, { replace: true });
        return toast.success(` Machine Model ${id ? "updated" : "created"}`, { autoClose: 1000 });
      } else return toast.warn(` Please try again!`);
    });
  };
  return (
    <div>
      {enableEdit ? (
        <Stack direction={"row"} sx={{ marginY: 5, marginLeft: "4%" }}>
          <Stack gap={1} flexWrap={"wrap"} sx={{ marginRight: 2 }}>
            <TextField
              style={{ boxShadow: "0px 3px 15px rgba(0,0,0,0.1)" }}
              value={formData.model}
              id="machine model"
              label="Machine Model"
              name="modelName"
              onChange={(newValue) => setFormData({ ...formData, model: newValue.target.value })}
              sx={{ minWidth: 350 }}
              error={!formData.model && errors.model}
              helperText={!formData.model && errors.model}
            />
            <TextField
              style={{ boxShadow: "0px 3px 15px rgba(0,0,0,0.1)" }}
              margin="normal"
              value={formData.manufacturer}
              id="manufacturer"
              label="Manufacturer"
              name="manufacturer"
              onChange={(newValue) => setFormData({ ...formData, manufacturer: newValue.target.value })}
              sx={{ minWidth: 350 }}
              error={!formData.manufacturer && errors.manufacturer}
              helperText={!formData.manufacturer && errors.manufacturer}
            />
          </Stack>
          <Stack>
            <Tooltip title="Save">
              <Button variant="contained" onClick={handleSaveButton}>
                Save
              </Button>
            </Tooltip>
          </Stack>
        </Stack>
      ) : (
        <Box sx={{ mx: 3, marginY: 2, marginLeft: "3%" }}>
          <Paper sx={{ borderRadius: 2, mb: 1.5, p: 3 }}>
            <Stack justifyContent={"space-between"} direction={"row"} flexWrap={"wrap"}>
              <Stack rowGap={1}>
                <Typography>
                  <span style={{ fontWeight: "bold" }}>Model:</span> {formData.model}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: "bold" }}>Manufacturer:</span> {formData.manufacturer}
                </Typography>
              </Stack>
              <Stack rowGap={1}>
                <Tooltip title="Edit model">
                  <Button onClick={() => setEnableEdit(true)} variant="contained">
                    Edit
                  </Button>
                </Tooltip>
              </Stack>
            </Stack>
          </Paper>
        </Box>
      )}
      <ToastContainer />
    </div>
  );
};

export default AddEditMachineModel;
